import { formatRelative } from '@koob/dates';
import Markdown from 'markdown-to-jsx';
import NotificationPopoverListItemActions from './NotificationPopoverListItemActions';
import NotificationPopoverListItemReadStatus from './NotificationPopoverListItemReadStatus';
import NotificationPopoverListItemIcon from './NotificationPopoverListItemIcon';

export default function NotificationPopoverListItem({
  notification,
  markAsRead,
  navigate,
  scope,
}) {
  return (
    <div key={notification.id} className="group border-b">
      <div className="relative py-2 px-3 transition rounded">
        <div className="absolute top-2 right-2">
          <NotificationPopoverListItemReadStatus read={!!notification.readAt} />
        </div>

        {!notification.readAt && (
          <div className="opacity-0 group-hover:opacity-100 absolute top-2 right-7 transition">
            <button
              className="text-xs text-gray-500 hover:text-k-orange transition border-0"
              onClick={() => markAsRead(notification.id)}
            >
              <i className="fa fa-check" />
            </button>
          </div>
        )}

        <div className="flex gap-3 items-center">
          <div className="flex justify-center items-center w-6">
            <NotificationPopoverListItemIcon notification={notification} />
          </div>

          <div className="w-full">
            <div className="text-sm font-medium text-gray-700">
              {notification.title}
            </div>
            <div className="mt-1 text-xs text-gray-500">
              <Markdown>{notification.description}</Markdown>
            </div>

            <div className="mt-2 flex justify-between items-center">
              <div>
                {notification?.actions?.length > 0 && (
                  <NotificationPopoverListItemActions
                    notification={notification}
                    navigate={navigate}
                    scope={scope}
                  />
                )}
              </div>

              <div className="text-right text-xs text-gray-400">
                {formatRelative(notification.createdAt)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
